/* @ngInject */
function CoreFiltersController (
  $rootScope,
  $scope,
  $q,
  $translate,
  AdminService,
  GroupService,
  ToastService,
  UserService,
  TaskTagsService,
  BriefingService,
  CampaignService
) {
  const api = {
    _handleChangeFilterItems,
    _handleGetResponseFilters,
    _getAllFilters,
    _successGetAllFilters,
    _errorGetResponse,
    _successGetInfiniteResponse,
    _errorGetInfiniteResponse,
    _applyFilterInParams,
    _getUserLocale,
    _successGetUserLocale,
    _getPromiseFilterList,
    _sortFilters,
    _mountItems,
    _getUserProfileImage,
    _hasMoreResults,
    _handleCompanyFeatures
  }

  $scope.filtersList = []
  $scope.params = {
    showDeskfyUser: undefined
  }

  $scope.flags = {
    top: 8,
    topForSelectFilters: 100,
    skip: null,
    firstLoad: true
  }

  $scope.isWorkflow = $rootScope?.companyWithBillingPackage?.billingPackage?.plan?.pricingPackage?.id === 4

  $scope.values = {
    taskCampaign: null,
    taskAssignees: [],
    taskStartDate: null
  }

  $scope.dynamicMinDate = null

  $scope.$watch('params.taskStartDate', function (newStartDate) {
    if (newStartDate) {
      const startDate = moment(newStartDate).format('YYYY-MM-DD')
      $scope.dynamicMinDate = startDate
    } else {
      $scope.dynamicMinDate = null
    }

    if ($scope.params.taskStartDate > $scope.params.taskDeliveryDate) {
      $scope.values.taskDeliveryDate = null
    }
  })

  $scope.companyFeatures = {}

  $scope.filters = {
    USERS: {
      promise: (search = '') => {
        const role = ['USER']
        const userFilters = {
          search,
          role
        }

        return AdminService.getUsers($scope.flags.top, $scope.flags.skip, userFilters)
      },
      mountItems: item => ({
        ...item,
        url: api._getUserProfileImage(item.id),
        label: item.name,
        value: item.id,
        icon: 'user'
      }),
      insertIntoParams: items => {
        $scope.params.users = items.length ? items.map(user => user.id) : []
      },
      disabled: false
    },
    GROUPS: {
      promise: (search = '') => {
        const simplified = null

        return GroupService.getGroups($scope.flags.top, $scope.flags.skip, { searchTerm: search }, simplified)
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.id
      }),
      insertIntoParams: items => {
        $scope.params.groups = items.length ? items.map(group => group.id) : []
      },
      disabled: false
    },
    USER_STATUS: {
      promise: () => {
        return Promise.resolve({
          rows: [
            { value: 'ACTIVE', name: $translate.instant('activeUser'), active: true },
            { value: 'INACTIVE', name: $translate.instant('inactiveUser') },
            { value: 'PENDING_INVITE', name: $translate.instant('invitePendingUser'), active: true },
            { value: 'REMOVED', name: $translate.instant('removedUser') }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: items => {
        $scope.params.status = items.length ? items.map(status => status.value) : []
      },
      disabled: false
    },
    TASK_ASSIGNEES: {
      promise: (search = '') => {
        return UserService.getAdministratorsAndDesigners({ top: $scope.flags.top, skip: $scope.flags.skip, search })
      },
      mountItems: item => ({
        ...item,
        url: api._getUserProfileImage(item.id),
        label: item.name,
        value: item.id,
        active: false,
        icon: 'user'
      }),
      insertIntoParams: items => {
        $scope.params.taskAssignees = items.length ? items.map(user => user.id || user.value) : []
      },
      disabled: false
    },
    TASK_PRIORITY: {
      promise: () => {
        return Promise.resolve({
          rows: [
            {
              name: $translate.instant('LOW'),
              value: 'LOW',
              icon: 'chevron-down',
              active: false
            },
            {
              name: $translate.instant('MEDIUM'),
              value: 'MEDIUM',
              icon: 'minus',
              active: false
            },
            {
              name: $translate.instant('HIGH'),
              value: 'HIGH',
              icon: 'chevron-up',
              active: false
            },
            {
              name: $translate.instant('URGENT'),
              value: 'URGENT',
              icon: 'chevron-up-double',
              active: false
            }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: item => {
        $scope.params.taskPriority = item?.value ?? ''
      },
      disabled: false
    },
    TASK_TAGS: {
      promise: (search = '') => {
        const flags = {
          top: $scope.flags.top,
          skip: $scope.flags.skip,
          search: search
        }

        return TaskTagsService.getTaskTags(flags)
      },
      mountItems: item => ({
        ...item,
        label: item.label,
        value: item.id
      }),
      insertIntoParams: items => {
        $scope.params.taskTags = items.length ? items.map(group => group.id) : []
      },
      disabled: false
    },
    TASK_BRIEFING: {
      promise: (search = '') => {
        return BriefingService.getCompanyBriefings(
          'WORKFLOW',
          null,
          search,
          $scope.flags.topForSelectFilters,
          $scope.flags.skip
        )
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.id
      }),
      insertIntoParams: item => {
        $scope.params.taskBriefing = item?.value ?? null
      },
      disabled: false
    },
    TASK_CAMPAIGN: {
      promise: (search = '') => {
        const flags = {
          top: $scope.flags.topForSelectFilters,
          skip: $scope.flags.skip,
          search: search,
          isAvailable: true
        }

        return CampaignService.getAllCampaigns(flags)
      },
      mountItems: item => ({
        ...item,
        label: item.title,
        value: item.id
      }),
      insertIntoParams: item => {
        $scope.params.taskCampaign = item?.value ?? null
      },
      disabled: false
    },
    TASK_START_DATE: {
      promise: () => {
        return Promise.resolve({ datePicker: true })
      },
      mountItems: item => (null),
      insertIntoParams: item => {
        $scope.params.taskStartDate = item?.date ?? null
      },
      disabled: false
    },
    TASK_DELIVERY_DATE: {
      promise: () => {
        return Promise.resolve({ datePicker: true })
      },
      mountItems: item => (null),
      insertIntoParams: item => {
        $scope.params.taskDeliveryDate = item?.date ?? null
      },
      disabled: false
    },
    GUEST_STATUS: {
      promise: () => {
        return Promise.resolve({
          rows: [
            { value: 'ACTIVE', name: $translate.instant('activeUser'), active: true },
            { value: 'INACTIVE', name: $translate.instant('inactiveUser') }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: items => {
        $scope.params.status = items.length ? items.map(status => status.value) : []
      },
      disabled: false
    },
    USER_PERMISSION: {
      promise: () => {
        const rows = [
          { value: 'ADMINISTRATOR', name: $translate.instant('administrator') },
          { value: 'DESIGNER', name: $translate.instant('designer') },
          { value: 'USER', name: $translate.instant('user') },
          { value: 'CONSULTANT', name: $translate.instant('consultant') }
        ]

        $rootScope.getCompanyConfigurations().then(configurations => {
          if (configurations?.ENABLE_MANAGERS) {
            rows.push({ value: 'MANAGER', name: $translate.instant('manager') })
          }
        })

        return Promise.resolve({
          rows,
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: items => {
        $scope.params.permissions = items.length ? items.map(permission => permission.value) : []
      },
      disabled: false
    },
    USER_PERMISSION_WORKFLOW: {
      promise: () => {
        return Promise.resolve({
          rows: [
            { value: 'ADMINISTRATOR', name: $translate.instant('administrator') },
            { value: 'DESIGNER', name: $translate.instant('designer') }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: items => {
        $scope.params.permissions = items.length ? items.map(permission => permission.value) : []
      },
      disabled: false
    },
    USER_INTERNAL: {
      promise: () => {
        return Promise.resolve({
          rows: [
            {
              name: $translate.instant('yes'),
              value: true
            },
            {
              name: $translate.instant('no'),
              value: false,
              active: true
            }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: item => {
        $scope.params.internalSearch = item?.value ?? null
      },
      disabled: false
    },
    COMPANY_STATUS: {
      promise: () => {
        return Promise.resolve({
          rows: [
            { value: 'TRIAL_ACTIVE', name: $translate.instant('generalBackoffice.companies.table.statusColumn.TRIAL_ACTIVE') },
            { value: 'TRIAL_EXPIRED', name: $translate.instant('generalBackoffice.companies.table.statusColumn.TRIAL_EXPIRED') },
            { value: 'CUSTOMER_ACTIVE', name: $translate.instant('generalBackoffice.companies.table.statusColumn.CUSTOMER_ACTIVE') },
            { value: 'CUSTOMER_CHURNED', name: $translate.instant('generalBackoffice.companies.table.statusColumn.CUSTOMER_CHURNED') },
            { value: 'BETA_ACTIVE', name: $translate.instant('generalBackoffice.companies.table.statusColumn.BETA_ACTIVE') }
          ],
          count: 0
        })
      },
      mountItems: item => ({
        ...item,
        label: item.name,
        value: item.value
      }),
      insertIntoParams: items => {
        $scope.params.companyStatus = items.length ? items.map(permission => permission.value) : []
      },
      disabled: false
    },
    TASK_AUTHOR: {
      promise: (search = '') => {
        const params = {
          search,
          role: $scope.isWorkflow ? ['GUEST'] : ['USER']
        }

        return AdminService.getUsers($scope.flags.topForSelectFilters, $scope.flags.skip, params)
      },
      mountItems: item => {
        delete item.active

        return {
          ...item,
          label: item.name,
          value: item.id
        }
      },
      insertIntoParams: item => {
        $scope.params.taskAuthor = item?.value ?? null
      },
      disabled: false
    }
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getUserLocale()
    api._handleChangeFilterItems($scope.filterItems)
    api._handleCompanyFeatures()
  }

  $scope.$watchCollection('params', () => {
    const filters = Object.keys($scope.params)
    filters.forEach(api._applyFilterInParams)
  })

  const deregisterHideFilter = $scope.$on('core-filters.set-hidden-filter', (event, filter, value) => {
    const filterIndex = $scope.filtersList.findIndex(f => f.type === filter)
    if (filterIndex !== -1) {
      $scope.filtersList[filterIndex].hidden = value
    }
  })

  const deregisterSetFilterValue = $scope.$on('core-filters.set-filter-value', (event, filter, value) => {
    const filterIndex = $scope.filtersList.findIndex(f => f.type === filter)

    if (filterIndex === -1) return

    if (filter === 'TASK_CAMPAIGN') {
      const filterItem = $scope.filtersList[filterIndex].items.find(item => item.value === value)
      if (filterItem) {
        $scope.values.taskCampaign = filterItem
        $scope.params.taskCampaign = filterItem.value
      }
    } else if (filter === 'TASK_BRIEFING') {
      const filterItem = $scope.filtersList[filterIndex].items.find(item => item.value === value)
      if (filterItem) {
        $scope.values.taskBriefing = filterItem
        $scope.params.taskBriefing = filterItem.value
      } else {
        $scope.values.taskBriefing = null
        $scope.params.taskBriefing = null
      }
    } else if (filter === 'TASK_ASSIGNEES') {
      $scope.params.taskAssignees = value.length ? value.map(assignee => assignee.value) : []
      $scope.values.taskAssignees = value
    } else if (filter === 'TASK_START_DATE') {
      $scope.params.taskStartDate = value
      $scope.values.taskStartDate = value
    } else if (filter === 'TASK_DELIVERY_DATE') {
      $scope.params.taskDeliveryDate = value
      $scope.values.taskDeliveryDate = value
    }
  })

  const deregisterSetFilterDisabled = $scope.$on('core-filters.set-filter-disabled', (event, filter, value) => {
    if ($scope.filters[filter]) {
      $scope.filters[filter].disabled = value
    }
  })

  $scope.$on('$destroy', () => {
    deregisterHideFilter()
    deregisterSetFilterValue()
    deregisterSetFilterDisabled()
  })

  $scope.onChangeSelect = (type, event) => {
    const { detail } = event

    if ($scope.filters[type]) {
      $scope.filters[type].insertIntoParams(detail)
    }
  }

  $scope.onInfiniteSelect = (type, event) => {
    $scope.flags.skip = $scope.flags.top + $scope.flags.skip
    $scope.flags.firstLoad = false

    api._handleGetResponseFilters(type, event)
  }

  $scope.onSearchSelect = (type, event) => {
    $scope.flags.skip = 0
    $scope.flags.firstLoad = false

    api._handleGetResponseFilters(type, event)
  }

  function _handleChangeFilterItems (newValue) {
    if (newValue) {
      const promises = newValue
        .sort(api._sortFilters)
        .map(filter => api._getPromiseFilterList(filter.name))
        .filter(Boolean)
      api._getAllFilters(promises)
    }
  }

  function _handleGetResponseFilters (type, event) {
    const search = event.detail?.search || ''
    const totalCount = event.detail?.totalCount

    const promise = $scope.filters[type].promise?.(search)

    promise
      .then(response => api._successGetInfiniteResponse(response, type, totalCount))
      .catch(api._errorGetInfiniteResponse)
  }

  /**
   *  @param {Array} promises - array of filters promises
   *  @description - this method get all filters, use async request
   */
  function _getAllFilters (promises) {
    $q.all(promises).then(api._successGetAllFilters)
  }

  /**
   *  @param {object} response
   *  @description - Success callback for get response from API
   */
  function _successGetAllFilters (response) {
    $scope.filtersList = $scope.filterItems
      .map((filter, index) => {
        const items = response[index]?.d?.results || response[index]?.rows
        const count = response[index]?.d?.__count || response[index]?.count
        const datePicker = response[index]?.datePicker

        if (datePicker) {
          return {
            id: filter.id,
            type: filter.name,
            order: filter.order,
            position: filter.position
          }
        }

        if (items) {
          const filterOptions = items.map(item => api._mountItems(filter.name, item)).filter(Boolean)
          let activeOptions = filterOptions.filter((option) => option.active === true)

          if (filter.name === 'USER_INTERNAL') {
            activeOptions = activeOptions[0]
          }

          $scope.filters[filter.name].insertIntoParams(activeOptions)

          return {
            id: filter.id,
            type: filter.name,
            order: filter.order,
            items: filterOptions,
            position: filter.position,
            hasMoreResults: api._hasMoreResults(count, items.length),
            hidden: filter.hidden
          }
        }
      })
      .filter(Boolean)

    $scope.filterParams.allFilters = $scope.filtersList
  }

  /**
   *  @description - Error callback for get response from API
   */
  function _errorGetResponse () {
    ToastService.defaultErrorToast()
  }

  /**
   *  @param {object} response
   *  @description - Success callback for get response from API
   */
  function _successGetInfiniteResponse (response, type, totalCount) {
    $scope.filtersList.forEach(filter => {
      if (filter.type === type) {
        const items = response?.d?.results || response?.rows
        const count = response?.d?.__count || response?.count

        const newItems = items
          .map(item => {
            return api._mountItems(filter.type, item)
          })
          .filter(Boolean)

        filter.items = newItems
        filter.hasMoreResults = api._hasMoreResults(count, totalCount)
      }
    })
  }

  /**
   *  @description - Error callback for get response from API
   */
  function _errorGetInfiniteResponse () {
    ToastService.defaultErrorToast()
  }

  /**
   *  @description - this method apply filter in params
   *
   *  @param {string} filter - filter key
   */
  function _applyFilterInParams (filter) {
    $scope.filterParams[filter] = $scope.params[filter]
  }

  /**
   *  @description - this method get locale of user
   */
  function _getUserLocale () {
    $rootScope.getUser().then(api._successGetUserLocale)
  }

  /**
   *  @param {object} locale - locale of user: ['PT-BR', 'EN-US', 'ES-ES']
   *  @description - Success callback for get locale of user
   */
  function _successGetUserLocale ({ locale }) {
    $scope.locale = locale
  }

  function _getPromiseFilterList (name) {
    if ($scope.filters[name]) {
      return $scope.filters[name].promise?.()
    }

    return null
  }

  function _sortFilters (a, b) {
    return a.order - b.order
  }

  function _mountItems (type, item) {
    if ($scope.filters[type]) {
      return $scope.filters[type].mountItems?.(item)
    }

    return null
  }

  function _getUserProfileImage (id, createdAt = '') {
    return UserService.getUserProfileImage(id, createdAt)
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  function _handleCompanyFeatures () {
    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.companyFeatures.boardStepAdvancedResources = !!features['WORKFLOW.BOARD_STEP_ADVANCED_RESOURCES']
    })
  }
}

export { CoreFiltersController }
